<template>
  <div class="addInviteGreyBg" tabindex="1" @focus="unshowInviteUnitTree">
    <transition name="slide-fade">
      <set-img
        v-show="drogShow"
        :src-data="initImg"
        @ad-change="chanel"
        @intercept="intercept"
        showMasking
        title="上传人脸"
      ></set-img>
    </transition>
    <div id="addInvite" class="addInvite" :class="[addInviteHeight1, addInviteHeight2]">
      <div class="addInvTitle" :class="lightBlue">
        <span>{{this.$props.childTitle}}</span>
        <i @click="addInvClose" class="el-icon-close"></i>
      </div>
      <div class="addInvBody">
        <div class="addInvWrap">
          <div class="addInvLeft">
            <div class="addphotoBox">
              <div class="img-close" v-if="isImg&&btnFlag.save">
                <i @click.stop="imgEmpty" class="fontFamily ryx-shequshanchu"></i>
              </div>
              <label>
                <img width="140" height="140" slot="placeholder" :src="visitorPhtoRealUrl" />
                <input
                  v-if="btnFlag.save"
                  type="file"
                  ref="file"
                  name="file"
                  class="el-upload__input"
                  @change="change"
                />
              </label>
              <!-- <vueCroppa :nochange="nochange" v-if="photoShowFlag" :myHeight='140' :myWidth='140' :initImg="this.visitorPhtoRealUrl" @on-picture="dealPicture">
                :removeButton="removeShow"
              </vueCroppa>-->
            </div>
            <p class="addInfo">点击上传头像</p>
            <p class="addTip">支持PNG、JPG文件</p>
            <p v-if="true" class="addTip">图片支持缩放、拖拽</p>
          </div>

          <div class="addInvRight">
            <div class="addInvGroup margRight">
              <label class="groupLabel" for="name">
                <span class="addMust">*</span>
                姓名 ({{visitorInfo.personCode}})
              </label>
              <el-input
                :disabled="disables.vnameShow"
                maxlength="20"
                v-model="visitorInfo.visitorName"
                placeholder="请输入"
              ></el-input>
            </div>
            <div class="addInvGroup">
              <label class="groupLabel" for="name">
                <span class="addMust">*</span>手机号
              </label>
              <el-input
                :disabled="disables.vtelShow"
                maxlength="11"
                v-model="visitorInfo.visitorTelphone"
                placeholder="请输入"
              ></el-input>
            </div>
            <div class="receptCompany">
              <label class="groupLabel" for="name">
                <span class="addMust">*</span>接待单位
              </label>
              <el-input
                :disabled="disables.corgName"
                v-model="visitorInfo.acceptDepart"
                placeholder="请选择接待单位"
                @click.native="showInviteUnitTree"
              ></el-input>
              <div v-if="treeShow" class="district-tree tree-shadow">
                <div class="district-left">
                  <!-- <keep-alive> -->
                  <div
                    tabindex="2"
                    v-loading="orgLoading"
                    v-if="inviteUnitTreeFlag"
                    style="width:308.3px;height:400px;position: fixed;z-index:9999;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);"
                    @focus.stop
                  >
                    <tree
                      ref="tree2"
                      :lazy="orgLazy"
                      :load="orgloadNode"
                      :props="orgProps"
                      :default-expanded-keys="orgExpandKeys"
                      @treenode-click="handleNodeClick"
                    ></tree>
                  </div>
                  <!-- </keep-alive> -->
                </div>
              </div>
            </div>
            <!-- <div class="addInvGroup margRight">
              <label class="groupLabel" for="name">
                <span class="addMust">*</span>访问次数</label>
              <el-select class="fixed-select-input" :disabled="disables.times" v-model="visitorInfo.visitorCount" placeholder="请选择">
                <el-option v-for="item in times" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>-->
            <div class="addInvGroup margRight">
              <label class="groupLabel" for="name">
                <span class="addMust">*</span>来访日期
              </label>
              <el-date-picker
                :disabled="disables.visitDate"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                v-model="visitorInfo.fromTime"
                type="datetime"
                :picker-options="pickerOptions0"
                placeholder="选择日期"
              ></el-date-picker>
            </div>
            <div class="addInvGroup">
              <label class="groupLabel" for="name">
                <span class="addMust">*</span>预计离去时间
              </label>
              <el-date-picker
                :default-time="'23:59:00'"
                :disabled="disables.visitDate"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                v-model="visitorInfo.leaveTime"
                type="datetime"
                :picker-options="pickerOptions0"
                placeholder="选择日期"
              ></el-date-picker>
            </div>
            <div class="addInvGroup margRight">
              <label class="groupLabel" for="name">访客卡号</label>
              <el-input
                :disabled="disables.vnameShow"
                maxlength="30"
                v-model="visitorInfo.cardNo"
                placeholder="请输入访客卡号"
              ></el-input>
            </div>
            <div class="addInvGroup" v-if="visitorInfo.id">
              <label class="groupLabel" for="name">身份证号</label>
              <el-input
                :disabled="disables.vnameShow"
                v-model="visitorInfo.visitorIdcard"
                placeholder="请输入身份证号"
              ></el-input>
            </div>
            <div class="addInvGroup" v-if="visitorInfo.licensePlateNo">
              <label class="groupLabel" for="name">车牌号</label>
              <el-input :disablecd="disables.vnameShow" v-model="visitorInfo.licensePlateNo"></el-input>
            </div>
            <div class="addInvGroup margRight" style="clear:both">
              <label class="groupLabel" for="name">接待人</label>
              <div class="addRadio">
                <el-radio-group
                  :disabled="disables.receptPerson"
                  v-model="visitorInfo.acceptPerson"
                  @change="operator"
                >
                  <el-radio label="0">本人</el-radio>
                  <el-radio label="1">其他人</el-radio>
                </el-radio-group>
                <div v-if="inviteTelShow">
                  <label class="groupLabel" for="name">接待人手机号</label>
                  <el-input
                    maxlength="11"
                    placeholder="请输入"
                    v-model="visitorInfo.acceptTelphone"
                    :disabled="teleDisable"
                  ></el-input>
                </div>
              </div>
            </div>
            <div class="addInvGroup">
              <label class="groupLabel" for="name">出入通知</label>
              <div class="addRadio">
                <el-radio-group :disabled="disables.isNotify" v-model="visitorInfo.isNotify">
                  <el-radio label="0">否</el-radio>
                  <el-radio label="1">是</el-radio>
                </el-radio-group>
                <div v-if="visitorInfo.column4">
                  <label class="groupLabel" for="name">所属中介公司</label>
                  <el-input
                    maxlength="11"
                    placeholder="请输入"
                    v-model="visitorInfo.column4"
                    :disabled="teleDisable"
                  ></el-input>
                </div>
              </div>
            </div>
            <div class="addInvDetail">
              <label class="groupLabel" for="name">来访事由</label>
              <el-input
                :disabled="disables.visitReason"
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                v-model="visitorInfo.visitReason"
                maxlength="200"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="addInvFoot fright">
        <!-- <div class="bbtn yellow marginRight" v-if="btnFlag.inviteAgain" @click="againInviter">再次邀请</div> -->
        <!-- <div v-operation-permission="'visitor/modify'" class="bbtn yellow marginRight" v-if="btnFlag.edit" @click="editInviter">编辑</div> -->
        <div class="bbtn blue"  v-if="btnFlag.cancelVisit" @click="cancelInviter">取消来访</div>
        <div
          class="bbtn yellow marginRight"
          v-if="btnFlag.commitAndInvite"
          @click="submitAndSave"
        >提交并继续邀请</div>
        <el-button class="bbtn blue" v-if="!btnFlag.save&&shouldShowPrintCodeButton" @click="printing">打印访客二维码</el-button>
        <el-button
          class="bbtn blue"
          v-if="btnFlag.save"
          @click="saveInviter"
          :loading="save"
        >{{save?'保存中':'保存'}}</el-button>
        <template
          v-if="!btnFlag.save&&singlevistiorInfo.recordStatus===3&&isShow(singlevistiorInfo)"
        >
          <div class="bbtn blue" @click="audit(1)">通过</div>
          <div class="bbtn" @click="audit(2)">驳回</div>
        </template>
        <div v-if="!btnFlag.save&&statusData" class="bbtn status" :class="statusData.class">{{statusData.text}}</div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import tree from '../../../components/tree/treeNew'
import vueCroppa from '../../../components/vue-croppa'
import cookie from '../../../utils/Tools/index'
import axios from 'axios'
import mixin from '../../mixins/allOrgTree'
import setImg from '../../../components/setImg'
let defaultFormat = 'yyyy-MM-dd hh:mm'
const defaultImg = require('../../../../static/images/uploadPic.jpg')
export default {
  components: {
    tree,
    vueCroppa,
    setImg
  },
  mixins: [mixin],
  props: {
    singlevistiorInfo: Object,
    // passInfo: Object,
    sourceInviteInfo: Object,
    childTitle: String,
    isFormatting: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.orgLoadingMode = 0
  },
  mounted () {
    this.userId = parseInt(cookie.getCookie('UserId')) // 获取cookie中存的用户名
    if (this.$store.getters.user.selectedProject) { this.orgSelectedProjectId = this.$store.getters.user.selectedProject.id }
    if (this.singlevistiorInfo.id) {
      let objs = this.$props.sourceInviteInfo
      let obj = this.$props.singlevistiorInfo
      this.syncData(this.$props.singlevistiorInfo)
      if (obj.visitorType === 2 || objs.visitorType === 2 || obj.visitorType === 1 || objs.visitorType === 1) {
        this.lightBlue = 'green'
        // 如果是自助登记修改则头部为绿色
        this.disables.vnameShow = true
        this.disables.vtelShow = true
        this.disables.corgName = true
        this.disables.times = true
        this.disables.visitDate = true
        this.disables.receptPerson = true
        this.disables.isNotify = true
        this.teleDisable = true
        this.disables.visitReason = true
        this.treeShow = false // 树隐藏
        this.nochange = 2 // 为2则标识图片不可修改
      }
      let psrecord = this.$props.sourceInviteInfo.id || this.singlevistiorInfo.id
      if (psrecord !== undefined) {
        this.disables.vnameShow = true
        this.disables.vtelShow = true
        this.disables.corgName = true
        this.disables.times = true
        this.disables.visitDate = true
        this.disables.receptPerson = true
        this.disables.isNotify = true
        this.disables.visitReason = true
        this.teleDisable = true
        this.treeShow = false // 树隐藏
        this.nochange = 2 // 为2则标识图片不可修改
      }
      this.id = obj.id
      // 根据props传过来的btnStatus判断切操作人是本人时显示的操作按钮,判断creater与存储的用户id是否相等
      if (obj.creator === this.userId) {
        if (obj.btnStatus === 0) {
          this.btnFlag.edit = true
          this.btnFlag.cancelVisit = true
          this.disables.vtelShow = true
          this.teleDisable = false
        } else if (obj.btnStatus === 1) {
          this.btnFlag.inviteAgain = true
          this.disables.vnameShow = true
          this.disables.vtelShow = true
          this.disables.corgName = true
          this.treeShow = false
          this.nochange = 2 // 为2则标识图片不可修改
        } else {
          // sonar规则校验语法必须else
        }
      }
    }
    this.activeDisBtn()
    this.calcForLayoutMiddle()
    if (this.singlevistiorInfo.stateName && (this.singlevistiorInfo.stateName.indexOf('有效中') !== -1 || this.singlevistiorInfo.stateName.indexOf('未到访问期') !== -1)) {
      this.shouldShowPrintCodeButton = true
    }
  },

  data () {
    return {
      // removeShow: true, // 删除图片按钮默认显示
      nochange: 1, // 上传图片为1可修改，2不可修改
      treeShow: true, // 组织树默认点击显示
      save: false,
      disables: {
        vnameShow: false, // 姓名
        vtelShow: false, // 电话
        corgName: false, // 组织
        times: false, // 访问次数
        visitDate: false, // 来访时间
        receptPerson: false, // 接待人
        isNotify: false, // 出入通知
        visitReason: false // 来访事由
      },
      initImg: '',
      drogShow: false,
      visitorInfo: {
        id: '', // 传过来这条信息的id
        userId: 0, // 存储用户id
        visitorName: '',
        projectName: '',
        visitorTelphone: '',
        acceptDepart: '', // 来访单位
        acceptDepartId: '', // 来访单位对应的ID
        isNotify: '0',
        visitorCount: '不限', // 接待次数
        fromTime: cookie.dateFormat(new Date(), defaultFormat), // 日期
        leaveTime: '',
        acceptPerson: '0', // 接待人
        acceptTelphone: '', // 接待人事“其他人”时输入的手机号
        visitReason: '', // 来访事由
        visitorType: 0, // 邀请0，登记1
        visitorPhto: '', // 访客邀请 图片名
        cardNo: '',
        licensePlateNo: '',
        quarryType: ''
        // visitorIdcard: '' // 访客的身份证
      },

      btnFlag: {
        inviteAgain: false,
        save: false,
        edit: false,
        cancelVisit: false,
        commitAndInvite: false
      },

      treedatad: {}, // 存储 组织树
      treedataValid: false, // 获取 组织树 数据是否有效

      inviteUnitTreeFlag: false, // 点击“接待单位”显示结构树
      myHeight: 140,
      myWidth: 140,
      saveMode: 0, // 0：提交并继续邀请；1：保存
      teleDisable: false, // 其他人手机号禁止修改

      visitorPhtoRealUrl: defaultImg,
      photoShowFlag: true,

      addInviteHeight1: '', // 弹框的高度
      addInviteHeight2: '', // 弹框的高度
      lightBlue: 'lightBlue',
      inviteTelShow: false, // 手机号输入框隐藏
      receptPerson: '0',
      value2: '',
      textarea: '',
      // 设置选择今天及今天往后的日期
      pickerOptions0: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      times: [
        {
          value: '999',
          label: '不限'
        },
        {
          value: '1',
          label: '1'
        },
        {
          value: '3',
          label: '3'
        },
        {
          value: '5',
          label: '5'
        }
      ],
      value: '',
      shouldShowPrintCodeButton: false
    }
  },

  computed: {
    isImg () {
      return this.visitorPhtoRealUrl !== defaultImg
    },
    listenCurrentNodeId () {
      return this.$store.getters.getCurrentNodeId
    },
    statusData () {
      if (this.singlevistiorInfo) {
        const nowDate = new Date()
        const leaveDate = new Date(this.singlevistiorInfo.leaveTime)
        if (leaveDate < nowDate) {
          return {
            class: 'expired',
            text: '已失效'
          }
        } else if (this.singlevistiorInfo.recordStatus === 0 || this.singlevistiorInfo.recordStatus === 1) {
          return {
            class: 'accepted',
            text: '已通过'
          }
        } else if (this.singlevistiorInfo.recordStatus === 4) {
          return {
            class: 'rejected',
            text: '已驳回'
          }
        } else {
          return null
        }
      } else {
        return null
      }
    }
  },

  watch: {
    'visitorInfo.acceptDepart': function (val) {
      this.$refs.tree2 && this.$refs.tree2.filter(val)
    }
  },

  methods: {
    printing () {
      this.$https.get('/visitor/getById', { visitorRecordId: this.visitorInfo.id, projectId: this.$store.getters.user.selectedProject.id || '' }).then(res => {
        if (res.code === '0') {
          window.open(`${window.location.origin}/#/printVisitorQrCode?data=${encodeURIComponent(JSON.stringify(res.data))}`, 'newwindow', 'height=500, width=800, top=100, left=100, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no')
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    isShow (obj) {
      let nowTimeRep = Date.now()
      var time = obj.leaveTime.replace(/-/g, '/')
      let leaveTime = new Date(time + ':59').getTime()
      return !(nowTimeRep > leaveTime && obj.recordStatus === 3)
    },
    audit (val) {
      this.$https.post('/wx/WXDJcheck', { visitorRecordId: this.id, result: val, operationName: cookie.getCookie('nickName') }).then(res => {
        if (res.code === '0') {
          this.$message({
            showClose: true,
            message: '审核成功！',
            type: 'success'
          })
          this.$emit('reChange')
          this.$emit('addInvChange')
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    imgEmpty () {
      this.visitorPhtoRealUrl = defaultImg
      this.visitorInfo.visitorPhto = ''
    },
    intercept (val) {
      if (val) {
        this.visitorPhtoRealUrl = axios.defaults.baseURL + 'v1/image/1/' + val
        this.visitorInfo.visitorPhto = val
      }
    },
    change (event) {
      var reader = new FileReader()
      var that = this
      if (event.target.files[0].type.indexOf('image/') === -1) {
        this.$message({
          showClose: true,
          message: '只能上传图片！',
          type: 'error'
        })
        return false
      }
      reader.readAsDataURL(event.target.files[0])
      reader.onload = function (e) {
        that.initImg = this.result
        that.drogShow = true
      }
    },
    chanel () {
      this.initImg = ''
      this.$refs.file.value = ''
      this.drogShow = false
    },
    // 关闭弹框
    addInvClose () {
      this.$emit('addInvChange', false)
    },
    // 操作人事件
    operator (w) {
      // 如果点击其他则显示身份证输入框
      if (w === '1') {
        this.inviteTelShow = true
        this.addInviteHeight2 = 'addInviteHeight2'
        this.addInviteHeight1 = ''
      } else {
        this.inviteTelShow = false
        this.addInviteHeight1 = 'addInviteHeight1'
        this.addInviteHeight2 = ''
      }
    },

    showInviteUnitTree () {
      this.inviteUnitTreeFlag = true
    },
    unshowInviteUnitTree () {
      this.inviteUnitTreeFlag = false
    },

    calcForLayoutMiddle () {
      let div = document.getElementById('addInvite')
      let valx = div.offsetWidth / 2
      let valy = div.offsetHeight / 2
      div.style.marginLeft = `-${valx}px`
      div.style.marginTop = `-${valy}px`
      div = null // NOSONAR
    },

    // 根据指定id 获取name
    findNameById (obj, specifyId) {
      for (let i of obj) {
        if (i.id === specifyId) {
          this.visitorInfo.acceptDepart = i.orgName
          this.visitorInfo.acceptDepartId = i.id
          return
        }

        this.findNameById(i.nodes, specifyId)
      }
    },

    submitAndSave () {
      this.$store.commit('changeIsTrue', false)
      this.photoShowFlag = false
      this.$nextTick(() => {
        this.photoShowFlag = true
      })
      this.saveMode = 0
      let port = 'webAddVisitorRecord/add?'
      this.doRequest(port).then(() => {
        this.clearData()
      })
      // this.visitorInfo.visitorPhto = '';
    },

    clearData () {
      // 清空数据
      this.visitorInfo.visitorType = ''
      this.visitorInfo.visitorName = ''
      this.visitorInfo.visitorTelphone = ''
      this.visitorInfo.acceptDepart = ''
      this.visitorInfo.visitorPhto = ''
      this.visitorInfo.acceptDepartId = ''
      this.visitorInfo.visitorCount = '不限'
      this.visitorInfo.visitorTimes = ''
      this.visitorInfo.acceptTelphone = ''
      this.visitorInfo.visitReason = ''
      this.visitorInfo.isNotify = '0'
      this.visitorPhtoRealUrl = defaultImg
    },

    saveInviter () {
      this.$store.commit('changeIsTrue', false)
      this.saveMode = 1
      let port = 'webAddVisitorRecord/add?'
      this.doRequest(port)
    },
    // 再次邀请
    againInviter () {
      // let id = this.id
      this.saveMode = 1
      // let port = 'webAddVisitorRecord/add?id=' + id + '&'
      // // let port = 'insertAgain';
      // this.doRequest(port)
      this.disables.vnameShow = false
      this.disables.vtelShow = false
      this.disables.corgName = false
      this.disables.times = false
      this.disables.visitDate = false
      this.disables.receptPerson = false
      this.disables.isNotify = false
      this.disables.visitReason = false
      this.visitorInfo.visitorTimes = ''
      this.btnFlag.inviteAgain = false
      this.btnFlag.save = true
      if (this.visitorPhtoRealUrl.indexOf('http') > -1) {
        var list = this.visitorPhtoRealUrl.split('/')
        this.visitorInfo.visitorPhto = list[list.length - 1]
      }

      this.$props.childTitle = '访客邀请'
    },
    // 取消来访
    cancelInviter () {
      let url = `visitor/cancelVisitor`
      let id = this.id
      this.$https
        .get(url, { id: id, projectId: this.$store.getters.user.selectedProject.id || '' })
        .then(res => {
          if (res.code === 'AUTH0000') {
            this.$message({
              showClose: true,
              message: '取消来访成功',
              type: 'success'
            })
            this.addInvClose()
            this.$emit('reChange') // 传递给父组件重新请求
            // window.location.href = window.location.href;
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 编辑
    editInviter () {
      let id = this.id
      this.saveMode = 1
      let port = 'webAddVisitorRecord/update?'
      this.doRequest(port, id)
    },

    doRequest (port, id) {
      let _visitorName = this.visitorInfo.visitorName ? this.visitorInfo.visitorName : ''
      let _visitorTelphone = this.visitorInfo.visitorTelphone ? this.visitorInfo.visitorTelphone : ''
      let _visitorPhto = this.visitorInfo.visitorPhto ? this.visitorInfo.visitorPhto : ''
      let _acceptDepart = this.visitorInfo.acceptDepartId ? this.visitorInfo.acceptDepartId : ''
      // let _visitorCount = this.visitorInfo.visitorCount;
      let _visitorTimes = this.visitorInfo.fromTime ? this.visitorInfo.fromTime : ''
      let time = new Date(_visitorTimes.replace(/-/g, '/'))
      let nextMonth = time.setMonth(time.getMonth() + 1)
      let _leaveTime = this.visitorInfo.leaveTime ? this.visitorInfo.leaveTime : ''
      // let _acceptPerson = this.visitorInfo.acceptPerson;
      // let _acceptTelphone = this.visitorInfo.acceptTelphone;
      let _acceptTelphone = ''
      let _visitReason = this.visitorInfo.visitReason ? this.visitorInfo.visitReason : ''
      let acceptUser = ''
      // let _visitorIdcard = this.visitorInfo.visitorIdcard;
      let _operateType = 1 // 新增操作人类型
      let _creator = this.userId

      // if (this.visitorInfo.visitorCount === '不限') {
      //   _visitorCount = 999
      // } else {
      //   _visitorCount = this.visitorInfo.visitorCount
      // }

      let engReg = /[a-zA-Z]/ // 英文验证
      // let numReg = /[0-9]/; // 数字验证
      let ChineseReg = /^[\u4e00-\u9fa5]+$/ // 中文验证
      let error = false

      // let specialCharsReg = /[~'!@#￥$%^&*()-+=:]/; // 特殊字符校验
      let projectName = this.visitorInfo.projectName || this.$store.getters.user.selectedProject.name
      if (projectName.indexOf('深圳璞悦山') > -1 && !_visitorPhto) {
        this.$message({
          showClose: true,
          message: '请选择上传图片',
          type: 'warning'
        })
        return false
      }
      if (_visitorName.length === 0) {
        this.$message({
          showClose: true,
          message: '姓名不能为空',
          type: 'warning'
        })
        return false
      } else if (!engReg.test(_visitorName) && !ChineseReg.test(_visitorName)) {
        this.$message({
          showClose: true,
          message: '姓名仅支持输入中英文',
          type: 'warning'
        })
        return Promise.reject(error)
      } else if (_visitorName.indexOf(' ') > 0) {
        this.$message({
          showClose: true,
          message: '姓名不能包含空格',
          type: 'warning'
        })
        return Promise.reject(error)
      } else if (!/^1\d{10}$/.test(_visitorTelphone)) {
        this.$message({
          showClose: true,
          message: '目前仅支持大陆手机号',
          type: 'warning'
        })
        return Promise.reject(error)
      } else if (isNaN(_visitorTelphone)) {
        this.$message({
          showClose: true,
          message: '手机号请输入数字',
          type: 'warning'
        })
        return Promise.reject(error)
      } else if (_visitorTelphone.indexOf(' ') > 0) {
        this.$message({
          showClose: true,
          message: '手机号不能包含空格',
          type: 'warning'
        })
        return Promise.reject(error)
      } else if (_acceptDepart.length === 0) {
        this.$message({
          showClose: true,
          message: '接待单位不能为空',
          type: 'warning'
        })
        return Promise.reject(error)
      } else if (_visitorTimes.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择来访日期',
          type: 'warning'
        })
        return Promise.reject(error)
      } else if (_leaveTime.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择预计离去时间',
          type: 'warning'
        })
        return Promise.reject(error)
      } else if (_visitorTimes >= _leaveTime) {
        this.$message({
          showClose: true,
          message: '离去时间要大于来访日期！',
          type: 'warning'
        })
        return Promise.reject(error)
      } else if (_visitorTimes < cookie.dateFormat(new Date(), defaultFormat)) {
        this.$message({
          showClose: true,
          message: '来访日期要大于当前时间！',
          type: 'warning'
        })
        return Promise.reject(error)
      } else if (_leaveTime > cookie.dateFormat(nextMonth, defaultFormat)) {
        this.$message({
          showClose: true,
          message: '拜访时间段要在一个月内！',
          type: 'warning'
        })
        return Promise.reject(error)
      } else {
        // sonar规则校验语法必须else
      }
      if (this.visitorInfo.acceptPerson === '0') {
        // this.visitorInfo.acceptTelphone = ''; // 本人时其他人手机号清空
        _acceptTelphone = ''
        acceptUser = this.userId
      } else {
        _acceptTelphone = this.visitorInfo.acceptTelphone
        if (_acceptTelphone.length !== 0) {
          if (_acceptTelphone.length !== 11) {
            this.$message({
              showClose: true,
              message: '请输入正确的接待人手机号',
              type: 'warning'
            })
            return false
          } else if (isNaN(_acceptTelphone)) {
            this.$message({
              showClose: true,
              message: '接待人手机号必须是数字',
              type: 'warning'
            })
            return false
          } else {
            // sonar规则校验语法必须else
          }
        } else {
          this.$message({
            showClose: true,
            message: '请输入接待人手机号',
            type: 'warning'
          })
          return false
        }
      }
      this.save = true
      let params = {
        visitorName: _visitorName,
        telphone: _visitorTelphone,
        faceId: _visitorPhto,
        acceptDepart: _acceptDepart,
        // visitorCount: _visitorCount,
        fromTime: _visitorTimes,
        leaveTime: _leaveTime,
        isSelf: this.visitorInfo.acceptPerson,
        acceptTelphone: _acceptTelphone,
        visitReason: _visitReason,
        creator: _creator,
        acceptUser: acceptUser,
        operateType: _operateType,
        isNotify: this.visitorInfo.isNotify,
        cardNo: this.visitorInfo.cardNo
      }
      this.$https.get('visitor/VisitorRecordRepeatCheck'
        , { fromTime: _visitorTimes,
          leaveTime: _leaveTime,
          telphone: _visitorTelphone,
          acceptDepart: _acceptDepart,
          visitorType: 0 }, false).then(res => {
        if (res.code === 'WX5000') {
          this.save = false
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let url = `visitor/${port}`
            params.id = res.data.id
            params.projectId = this.$store.getters.user.selectedProject.id || ''
            this.summit(url, params)
          })
        } else if (res.code === '0') {
          let url = `visitor/${port}`
          if (id) {
            params.id = id
          }
          params.projectId = this.$store.getters.user.selectedProject.id || ''
          this.summit(url, params)
        } else {
          this.save = false
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.save = false
      })
    },
    summit (url, data) {
      return this.$https.post(url, data, null, false).then(res => {
        this.save = false
        if (res.msg === '成功') {
          this.visitorInfo = {} // 清空访客信息列表
          // this.infoMessage('保存成功');
          this.$message({
            showClose: true,
            message: '保存成功',
            type: 'success'
          })
          if (this.saveMode === 1) {
            this.addInvClose()
            this.$emit('reChange') // 传递给父组件重新请求
          }
        } else if (res.code === 'WX5000') {
          this.$message({
            showClose: true,
            message: '请勿重复邀请',
            type: 'warning'
          })
        } else {
          // this.infoMessage(res.msg);
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }).catch(() => {
        this.save = false
      })
    },
    dealPicture (val) {
      this.visitorInfo.visitorPhto = val.data
    },
    syncData (obj) {
      this.visitorInfo.visitorName = obj.visitorName
      this.visitorInfo.visitorTelphone = obj.visitorTelphone
      this.visitorInfo.personCode = obj.visitorCode
      this.visitorInfo.acceptDepart = obj.acceptDepartName
      this.visitorInfo.acceptDepartId = obj.acceptDepart
      this.visitorInfo.cardNo = obj.cardNo
      this.visitorInfo.id = obj.id
      this.visitorInfo.isNotify = (obj.isNotify !== null && obj.isNotify.toString())
      this.visitorInfo.leaveTime = obj.leaveTime
      this.visitorInfo.fromTime = obj.fromTime
      this.visitorInfo.visitorIdcard = !this.btnFlag.save ? cookie.cardNumberFormat(obj.visitorIdcard) : obj.visitorIdcard
      this.visitorInfo.licensePlateNo = obj.licensePlateNo
      this.visitorInfo.quarryType = obj.quarryType
      this.visitorInfo.column4 = obj.column4
      if (obj.acceptPerson) {
        this.visitorInfo.acceptPerson = '0'
      } else {
        this.visitorInfo.acceptPerson = '1'
        this.visitorInfo.acceptTelphone = obj.acceptTelphone
        this.inviteTelShow = true
      }
      // 访问次数是999时显示访问次数不限
      if (obj.visitorCount === 999) {
        this.visitorInfo.visitorCount = '不限'
      } else {
        this.visitorInfo.visitorCount = obj.visitorCount
      }

      let _d = new Date(obj.visitorTime) // 根据时间戳生成的时间对象
      let _date =
        _d.getFullYear() + '-' + (_d.getMonth() + 1) + '-' + _d.getDate()
      this.visitorInfo.visitorTimes = _date
      this.visitorInfo.visitReason = obj.vistorReason
      // this.teleDisable = true;
      this.visitorInfo.visitorPhto = obj.visitorPhto
      if (obj.visitorPhoto) {
        this.visitorPhtoRealUrl = obj.visitorPhoto
        this.photoShowFlag = false
        setTimeout(() => {
          this.photoShowFlag = true
        }, 500)
      }
    },

    activeDisBtn () {
      let _type = this.$props.singlevistiorInfo.type
      if (_type === 'invite' || _type === 'register') {
        this.btnFlag.commitAndInvite = true
        this.btnFlag.save = true
      } else if (_type === 'check') {
        let _userId = cookie.getCookie('UserId')
        if (this.$props.singlevistiorInfo.creator && this.$props.singlevistiorInfo.creator.toString() === _userId.toString()) {
          let _sta = this.$props.singlevistiorInfo.stateName

          if (
            _sta === '已来访，已失效' ||
            _sta === '未来访，已失效' ||
            _sta === '已取消'
          ) {
            this.btnFlag.inviteAgain = true
          } else if (_sta === '未到访问期' || _sta === '未来访，有效中') {
            this.btnFlag.edit = true
            this.btnFlag.cancelVisit = true
          } else {
            // sonar规则校验语法必须else
          }
        }
      } else {
        // sonar规则校验语法必须elsesole.log(_type)
      }
    },
    handleNodeClick (d) {
      if (d.children.length === 0) {
        this.isChildren(d).then(res => {
          if (d.disabled === false && res) {
            this.visitorInfo.acceptDepart = d.name
            this.visitorInfo.acceptDepartId = d.id
            this.visitorInfo.projectName = d.projectName
            this.unshowInviteUnitTree()
          }
        })
      }
    }
  }
}
</script>
<style lang="less">
.addInviteGreyBg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.6);
  .addInviteHeight1 {
    height: 52.5rem;
  }
  .green {
    background-color: #49c1bd;
  }
  .lightBlue {
    background-color: #6e9dd3;
  }
  .addInvite {
    width: 690px;
    position: absolute;
    top: 50%;
    left: 50%;
    // transform: translate(-50%, -50%);
    background-color: #ffffff;
    border-radius: 5px;
    .addInvTitle {
      height: 4rem;
      line-height: 4rem;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
      font-size: 1.4rem;
      color: #ffffff;
      overflow: hidden;
      .el-icon-close {
        float: right;
        margin-top: 1.5rem;
        font-size: 1.6rem;
      }
    }
    .addInvBody {
      width: 100%;
      .addInvWrap {
        // overflow: hidden;
        // border-bottom: 1px solid #dfdfdf;
        // margin-left: 1.5rem;
        // margin-right: 1.5rem;
        // padding-bottom: 1rem;
        height: auto;
        overflow: hidden;
        border-bottom: 1px solid #dfdfdf;
        padding-bottom: 0.5rem;
        .addInvLeft {
          // margin-top: 2.5rem;
          // float: left;
          // width: 16rem;
          // height: 10rem;
          float: left;
          width: 180px;
          .addphotoBox {
            img {
              cursor: pointer;
              &:hover {
                box-shadow: 0 0 4px 0px fade(#000000, 20%);
              }
            }
            width: 140px;
            height: 140px;
            margin-left: 2rem;
            margin-top: 2.5rem;
            line-height: 10rem;
            text-align: center;
            background-color: #f3f3f3;
            position: relative;
          }
          text-align: center;
          .addInfo {
            // font-size: 1.17rem;
            // color: #606266;
            // text-align: center;
            // margin-bottom: 0.83rem;
            margin-top: 1.33rem;
            height: 2rem;
            line-height: 2rem;
            text-align: center;
          }
          .addTip {
            // font-size: 1rem;
            // color: #c5c5c5;
            // text-align: center;
            // margin-bottom: 0.83rem;
            margin-top: 1rem;
            height: 1.5rem;
            line-height: 1.5rem;
            text-align: center;
            color: #c5c5c5;
            font-size: 1.2rem;
          }
        }
        .margRight {
          margin-right: 5%;
        }
        .addInvRight {
          float: left;
          width: 490px;
          padding-left: 1.5rem;
          padding-bottom: 1.5rem;
          margin-top: 2rem;
          border-left: 1px solid #dfdfdf;
          max-height: 480px;
          overflow-y: auto;
          overflow-x: hidden;
          .receptCompany {
            width: 100%;
            float: left;
            .recCompany {
              -webkit-appearance: none;
              background-color: #fff;
              background-image: none;
              border-radius: 4px;
              border: 1px solid #dcdfe6;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              color: #606266;
              display: inline-block;
              font-size: inherit;
              height: 40px;
              line-height: 40px;
              outline: 0;
              padding: 0 15px;
              -webkit-transition: border-color 0.2s
                cubic-bezier(0.645, 0.045, 0.355, 1);
              transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
              width: 100%;
            }
            .groupLabel {
              height: 3rem;
              line-height: 3rem;
              display: block;
              width: 100%;
              font-size: 1.2rem;
              .addMust {
                color: red;
                margin-right: 0.5rem;
              }
            }
          }
          .addInvDetail {
            width: 100%;
            float: left;
            .groupLabel {
              height: 3rem;
              line-height: 3rem;
              display: block;
              width: 100%;
              font-size: 1.2rem;
            }
          }
          .addInvGroup {
            width: 47.5%;
            float: left;
            .el-select .el-input__inner {
              padding-right: 61px !important;
            }
            .groupLabel {
              height: 3rem;
              line-height: 3rem;
              display: block;
              width: 100%;
              font-size: 1.2rem;
              .addMust {
                color: red;
                margin-right: 0.5rem;
              }
            }
            .regID {
              -webkit-appearance: none;
              background-color: #fff;
              background-image: none;
              border-radius: 4px;
              border: 1px solid #dcdfe6;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              color: #606266;
              display: inline-block;
              font-size: inherit;
              height: 40px;
              line-height: 40px;
              outline: 0;
              padding: 0 15px;
              -webkit-transition: border-color 0.2s
                cubic-bezier(0.645, 0.045, 0.355, 1);
              transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
              width: 100%;
            }
          }
        }
      }
    }
    .addInvFoot {
      padding: 1.5rem;
    }
    .fixed-select-input {
      /* TODO 修复element修改样式bug */
      input {
        height: 36px !important;
      }
    }
    .bbtn.status {
      background: #dcdfe6;
      &.accepted {
        color: #1E9FFF;
      }
      &.rejected {
        color: red;
      }
      &.expired {
        color: gray;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personManage/common/addInvite.vue